<template>
  <div class="roleBox">
    <Form ref="searchForm" :label-width="80" :model="formCustom" inline>
      <Form-item label="角色名称：" prop="roleName">
        <Input v-model="formCustom.roleName" :maxlength="50" clearable placeholder="请输入"
               style="width: 200px"></Input>
      </Form-item>
      <Form-item label="状态：" prop="status">
        <Select v-model="formCustom.status" clearable filterable style="width: 200px" @on-change="changeStatus">
          <Option value="1">有效</Option>
          <Option value="-1">锁定</Option>
        </Select>
      </Form-item>
      <Form-item>
        <Button type="primary" @click="handleSearch">查询</Button>
        <Button class="iviewButton" @click="handleReset('searchForm')">重置</Button>
      </Form-item>
    </Form>
    <div style="margin-bottom: 20px">
      <Button v-if="btnList.includes('新增')" type="primary" @click="handleButton('add')">新增</Button>
    </div>
    <div>
      <Table :columns="roleColumns" :data="roleTableData" :loading="loading" aria-describedby="" aria-hidden="true"
             border>
        <template slot="roleType" slot-scope="{ row }">
          <span>{{ row.roleType | setRoleType }}</span>
        </template>
        <template slot="action" slot-scope="{ row }">
          <Button v-if="btnList.includes('权限配置')" size="small" type="text"
                  @click="handleButton('authority', row.roleId)">权限配置
          </Button>
          <Button v-if="btnList.includes('编辑')" size="small" type="text" @click="handleButton('edit', row.roleId)">
            编辑
          </Button>
          <Button v-if="btnList.includes('删除')" size="small" type="text" @click="remove(row.roleId)">删除</Button>
          <Button v-if="row.status === '有效' && btnList.includes('锁定')" size="small" type="text"
                  @click="lockButton('lock', row.roleId)">锁定
          </Button>
          <Button v-if="row.status === '锁定' && btnList.includes('锁定')" size="small" type="text"
                  @click="lockButton('unlock', row.roleId)">解锁
          </Button>
        </template>
      </Table>
      <Page ref="pages" :current="page" :total="total" class="page_position" show-elevator show-sizer show-total
            @on-change="setCurrent" @on-page-size-change="setPage"></Page>
    </div>
  </div>
</template>

<script>
import {roleDelete, roleLock, rolePage} from '@/api/authority'
import permissionList from '@/libs/handlePermission.ts'

export default {
  name: 'role',
  filters: {
    setRoleType: function (value) {
      switch (value) {
        case 0:
          return '超级管理员'
        case 1:
          return '中智专管员'
        case 2:
          return '前道'
        case 3:
          return '后道'
        default:
          return '系统找不到'
      }
    }
  },
  data() {
    return {
      total: 0,
      page: 1,
      size: 10,
      pageSize: 10,
      loading: false, // 表格等待
      lockMsg: '', // 锁定/解锁
      lockStatus: '', //锁定/解锁状态
      btnList: [],
      formCustom: {
        roleName: '',
        status: ''
      },
      roleColumns: [
        // {type: 'selection', width: 60, align: 'center'},
        {title: '创建时间', key: 'createTime', width: 260, align: 'center'},
        {title: '角色名称', key: 'roleName', align: 'center'},
        {title: '角色类型', slot: 'roleType', align: 'center'},
        {title: '别名', key: 'remarks', align: 'center'},
        {title: '排序', key: 'orderBy', width: 100, align: 'center'},
        {title: '状态', key: 'status', width: 100, align: 'center'},
        {title: '操作', slot: 'action', minWidth: 140, align: 'center', fixed: 'right'}
      ],
      roleTableData: [] // 表格数据
    }
  },
  mounted() {
    const list = JSON.parse(localStorage.getItem('routerList'))
    // eslint-disable-next-line new-cap
    this.btnList = new permissionList(list, this.$route.path).getList()
    if (this.$route.query.current !== undefined) {
      this.page = parseInt(this.$route.query.current)
      this.pageSize = parseInt(this.$route.query.size)
      if (this.$route.query.roleName !== undefined && this.$route.query.roleName !== '') {
        this.formCustom.roleName = this.$route.query.roleName;
      }
      if (this.$route.query.status !== undefined && this.$route.query.status !== '') {
        this.formCustom.status = this.$route.query.status;
      }

      this.setCurrent(this.page)
    } else {
      this.init()
    }
  },
  methods: {
    // 初始化
    init() {
      this.loading = true
      rolePage({
        current: 1,
        size: 10
      }).then((res) => {
        this.changeData(res)
      })
    },
    // 调接口获取表格数据
    changeData(res) {
      this.total = res.data.data.total
      this.size = res.data.data.size
      this.roleTableData = res.data.data.records
      res.data.data.records.forEach((element, index) => {
        if (element.status === -1) {
          this.roleTableData[index].status = '锁定'
        } else if (element.status === 1) {
          this.roleTableData[index].status = '有效'
        }
      })
      this.loading = false
    },
    // 查询
    handleSearch() {
      rolePage({
        current: 1,
        size: this.pageSize,
        roleName: this.formCustom.roleName,
        status: this.formCustom.status
      }).then((res) => {
        this.changeData(res)
        this.$refs['pages'].currentPage = 1 // 分页变成第一页
      })
    },
    // 重置
    handleReset(name) {
      this.$refs[name].resetFields()
      // 重置查询条件会再次查询
      this.handleSearch()
    },
    // 获取下拉框状态数据
    changeStatus(val) {
      this.formCustom.status = val
    },
    // 新增/编辑跳转
    handleButton(val, id) {
      switch (val) {
        case 'add':
          this.$router.push(
            {
              path: '/authority/role/roleAdd',
              query: {
                current: this.page,
                size: this.pageSize,
                roleName: this.formCustom.roleName,
                status: this.formCustom.status
              }
            }
          )
          break
        case 'edit':
          this.$router.push(
            {
              path: '/authority/role/roleEdit',
              query: {
                roleId: id,
                current: this.page,
                size: this.pageSize,
                roleName: this.formCustom.roleName,
                status: this.formCustom.status
              }
            }
          )
          break
        case 'authority':
          this.$router.push(
            {
              path: '/authority/role/roleAuthority',
              query: {
                roleId: id,
                current: this.page,
                size: this.pageSize,
                roleName: this.formCustom.roleName,
                status: this.formCustom.status
              }
            }
          )
          break
        default:
          break
      }
    },
    // 改变页码
    setCurrent(val) {
      this.loading = true
      this.page = val
      rolePage({
        current: val,
        size: this.pageSize,
        roleName: this.formCustom.roleName,
        status: this.formCustom.status
      }).then((res) => {
        this.changeData(res)
      })
    },
    // 改变每页条数
    setPage(val) {
      this.loading = true
      this.pageSize = val
      rolePage({
        current: 1,
        size: this.pageSize,
        roleName: this.formCustom.roleName,
        status: this.formCustom.status
      }).then((res) => {
        this.changeData(res)
        this.$refs['pages'].currentPage = 1 // 分页变成第一页
      })
    },
    // 锁定/解锁
    lockButton(val, id) {
      if (val === 'lock') {
        this.lockMsg = '确认锁定？'
        this.lockStatus = -1
      } else if (val === 'unlock') {
        this.lockMsg = '确认解锁？'
        this.lockStatus = 1
      }
      this.$Modal.confirm({
        title: this.lockMsg,
        onOk: () => {
          roleLock({
            roleId: id,
            status: this.lockStatus
          }).then((res) => {
            this.$Message.success(res.data.msg)
            this.init()
          }).catch(() => {
            if (val === 'lock') {
              this.$Message.error('锁定失败')
            } else if (val === 'unlock') {
              this.$Message.error('解锁失败')
            }
          })
        },
        onCancel: () => {
          if (val === 'lock') {
            this.$Message.info('已取消锁定')
          } else if (val === 'unlock') {
            this.$Message.info('已取消解锁')
          }
        }
      })
    },
    // 删除
    remove(id) {
      this.$Modal.confirm({
        title: '确认删除？',
        onOk: () => {
          roleDelete(id).then((res) => {
            if (res.data.success === false) {
              this.$Message.warning(res.data.msg)
            } else {
              this.$Message.success(res.data.msg)
            }
            this.init()
          }).catch(() => {
          })
        },
        onCancel: () => {
          this.$Message.info('已取消删除')
        }
      })
    }
  }
}
</script>
